import {
  Alert,
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Row,
} from "reactstrap";
import {
  ActionButtonContainer,
  AdvancedSettingsContainer,
  AgentDefinition,
  // AdvancedSettingsContainer,
  CardVideo,
  FormInputText,
  GptForm,
  GptKnowledgeContainer,
  ProjectDetailsContainer,
} from "./styled";
import { DropzoneFile, HUNDRED_MB } from "../../../components/shared/DropzoneFile";
import { useEffect, useState } from "react";
import { IModel, ISource, modelService, projectService, sourcesService } from "../../../services";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../redux/authenticationSlice";
import { useBlocker, useNavigate } from "react-router-dom";
import { ShareGPTModal } from "../../../components/Modals/ShareGPTModal";
import { IUserMicrosoft, PermissionsArray } from "../../../services/users";
import { GrantedUsersTable } from "../../../components/Projects/GrantedUsersTable";
import { routesManager } from "../../../routes/routesManager";
import { LoadingOverlay } from "../../../components/shared/LoadingOverlay";
import { useDispatch } from "react-redux";
import {
  actionSetLoading,
  actionSetProjects,
  selectorLoadingProgress,
} from "../../../redux/projectSlice";
import { actionSelectChat } from "../../../redux/chatSlice";
import { actionDisplayNotification } from "../../../redux/notificationSlice";
import { useTranslation } from "react-i18next";
import { SuccessCreateGPTModal } from "../../../components/Projects/SuccessCreateGPTModal";
import { useGPTForm } from "./useGPTForm";
import { selectorMicrosoftUsers } from "../../../redux/userSlice";
import { ExitWithoutSaveModal } from "../../../components/Modals/ExitWithoutSaveModal";
import VideoCard from "../../../assets/Tela-fixa-1.png";
import TagManager from "react-gtm-module";
import { jwtDecode } from "jwt-decode";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import { RiInformation2Line } from "@remixicon/react";
import { CreateModalAgentPrompt } from "../../../components/Modals/NewAgentPromptModal";
import { IPrompt, promptsService } from "../../../services/prompts";
import { PromptsTable } from "../../../components/Projects/PromptsTable";
import { v4 as uuidv4 } from "uuid";

export interface SelectedUsersWithPermissions {
  user: IUserMicrosoft;
  delete: boolean;
  upload: boolean;
  change?: boolean;
}

interface IUserData {
  email: string;
}

const iconPaths = [
  "defaultIcon.svg",
  "icon1.svg",
  "icon2.svg",
  "icon3.svg",
  "icon4.svg",
  "icon5.svg",
  "icon6.svg",
  "icon7.svg",
  "icon8.svg",
  "icon9.svg",
  "icon10.svg",
  "icon11.svg",
  "icon12.svg",
  "iconkyno.svg",
  "iconsap.svg",
];

export function ProjectDetails() {
  const userData = useSelector(selectUserData);
  const microsoftUsers = useSelector(selectorMicrosoftUsers);
  const loadingProgress = useSelector(selectorLoadingProgress);
  const dispatch = useDispatch();
  const id = sessionStorage.getItem("project-id-form");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    errors,
    formData,
    getAllFieldsFilled,
    getHasError,
    setFormData,
    shouldDisableFields,
    validateForm,
    isEditing,
    dirt,
    setDirt,
    handleChange,
  } = useGPTForm();

  const [loading, setLoading] = useState<boolean>(false);
  const [openShareModal, setOpenShareModal] = useState<boolean>(false);
  const [openSuccessCreateModal, setOpenSuccessCreateModal] = useState<boolean>(false);
  const [openAgentPromptModal, setOpenAgentPromptModal] = useState<boolean>(false);
  const [prompts, setPrompts] = useState<IPrompt[]>([]);
  const [selectedGrantedUsers, setSelectedGrantedUsers] = useState<SelectedUsersWithPermissions[]>(
    [],
  );
  const [sources, setSources] = useState<ISource[]>([]);
  const [models, setModels] = useState<IModel[]>([]);
  const [filesToUpload, setFilesToUpload] = useState<File[]>([]);
  const [accessToUpload, setAccessToUpload] = useState<boolean>(false);
  const [accessToDelete, setAccessToDelete] = useState<boolean>(false);
  const [accessToDownload, setAccessToDownload] = useState<boolean>(false);

  const jwt = localStorage.getItem("jwt") as string;
  const decodedToken = jwtDecode(jwt) as IUserData;

  const [temperatureValue, setTemperatureValue] = useState(0.1);
  const [minScoreValue, setMinScoreValue] = useState(0.1);
  const [documentsValue, setDocumentsValue] = useState(50);
  const [iconValue, setIconValue] = useState<string>("defaultIcon.svg");

  const [isIconDropdown, setIsIconDropdown] = useState<boolean>(false);

  const [editKnowledgeId, setEditKnowledgeId] = useState<number | undefined>(undefined);

  const addToPrompts = (newPrompt: IPrompt) => {
    setPrompts((prev) => (prev ? [newPrompt, ...prev] : [newPrompt]));
  };

  const toggleIconDropdown = () => {
    setIsIconDropdown(!isIconDropdown);
  };

  const handleSlideTemperature = (values: string[]) => {
    setTemperatureValue(parseFloat(values[0]));
  };
  const handleSlideMinScore = (values: string[]) => {
    setMinScoreValue(parseFloat(values[0]));
  };
  const handleSlideDocuments = (values: string[]) => {
    setDocumentsValue(parseInt(values[0]));
  };

  const pipsOptionsIntValues = {
    mode: "steps",
    values: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    density: 9,
    format: {
      to: (value: any) => value.toFixed(0),
      from: (value: any) => parseInt(value),
    },
  };

  const pipsOptionsFloatValues = {
    mode: "steps",
    values: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    density: 10,
    format: {
      to: (value: any) => value.toFixed(1),
      from: (value: any) => parseFloat(value),
    },
  };

  const { state, proceed, reset } = useBlocker(
    ({ currentLocation, nextLocation }) =>
      nextLocation.pathname !== currentLocation.pathname && dirt,
  );

  const onFileUpload = async (knowledgeId: number) => {
    await sourcesService.uploadSources({
      files: filesToUpload,
      knowledgeId,
    });
  };

  const trackGTMEvent = (eventName: string, eventData: Record<string, unknown>) => {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        ...eventData,
        timestamp: new Date().toISOString(),
      },
    });
  };

  const onInviteUsers = async (projectId: number) => {
    // segregate users by permissions
    const usersWithPermissions = selectedGrantedUsers
      .filter((users) => users.change)
      .reduce(
        (acc, user) => {
          if (user.delete && user.upload) {
            acc.deleteAndUpload.push(user.user.email);
          } else if (user.delete) {
            acc.delete.push(user.user.email);
          } else if (user.upload) {
            acc.upload.push(user.user.email);
          } else {
            acc.onlyRead.push(user.user.email);
          }
          return acc;
        },
        {
          delete: [] as string[],
          upload: [] as string[],
          deleteAndUpload: [] as string[],
          onlyRead: [] as string[],
        },
      );
    const inviteParams = [
      {
        projectId,
        emails: usersWithPermissions.delete,
        permissions: ["files:delete"] as PermissionsArray,
      },
      {
        projectId,
        emails: usersWithPermissions.upload,
        permissions: ["files:upload", "files:delete"] as PermissionsArray,
      },
      {
        projectId,
        emails: usersWithPermissions.deleteAndUpload,
        permissions: ["files:delete", "files:upload"] as PermissionsArray,
      },
      {
        projectId,
        emails: usersWithPermissions.onlyRead,
        permissions: [] as PermissionsArray,
      },
    ]
      .filter((param) => param.emails.length)
      .map(async (param) => await projectService.inviteManyUserToProject(param));
    return inviteParams;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validateForm();
    if (getHasError()) return;
    setDirt(false);

    const body = {
      title: formData.name,
      description: formData.description,
      welcome_message: formData.welcome_message,
      system_tone: formData.prompt,
      is_public: formData.isPublic,
      download_docs: formData.downloadDocs,
      internal_knowledge_only: formData.internalKnowledgeOnly,
      icon: iconValue,
      priority: formData.priority,
      temperature: temperatureValue,
      seed: "42",
      number_of_documents_retrived_to_context: documentsValue,
      min_score: minScoreValue,
      external: formData.internalKnowledgeOnly ? false : formData.external,
      model_id: formData.model_id,
    };

    try {
      let projectId = parseInt(id as string);
      let knowledgeId = editKnowledgeId;
      const ADD_PROGRESS = 20;
      dispatch(
        actionSetLoading({
          load: true,
          loadingProgess: loadingProgress + ADD_PROGRESS,
          loadingText: "Salvando projeto",
        }),
      );
      setLoading(true);

      if (isEditing && id && (formData.owner?.id === userData?.id || userData?.is_superuser)) {
        dispatch(
          actionSetLoading({
            load: true,
            loadingProgess: loadingProgress + ADD_PROGRESS,
            loadingText: "Seu projeto está sendo editado",
          }),
        );
        const editedGpt = await projectService.editProject({ project: body, project_id: id });

        trackGTMEvent("projectEditClic", {
          projectId: editedGpt.id,
          username: decodedToken.email.split("@")[0],
        });

        projectId = editedGpt.id;
      } else if (!isEditing) {
        dispatch(
          actionSetLoading({
            load: true,
            loadingProgess: loadingProgress + ADD_PROGRESS,
            loadingText: "Seu projeto está sendo criado",
          }),
        );
        const createdGpt = await projectService.createProject(body);

        trackGTMEvent("createNewProjectClick", {
          projectId: createdGpt.id,
          username: decodedToken.email.split("@")[0],
        });

        projectId = createdGpt.id;
        knowledgeId = createdGpt.knowledge_id;
      }
      if (!!filesToUpload.length && accessToUpload && knowledgeId) {
        dispatch(
          actionSetLoading({
            load: true,
            loadingProgess: loadingProgress + ADD_PROGRESS,
            loadingText: "Seus arquivos estão sendo enviados",
          }),
        );
        await onFileUpload(knowledgeId);
      }
      if (!!selectedGrantedUsers.length && !formData.isPublic) {
        dispatch(
          actionSetLoading({
            load: true,
            loadingProgess: loadingProgress + ADD_PROGRESS,
            loadingText: "Usuários estão sendo convidados",
          }),
        );
        await onInviteUsers(projectId);
      }

      const projects = await projectService.listProjects();
      dispatch(actionSetProjects(projects));

      dispatch(
        actionSelectChat({ selectedChatId: projectId, emptyChat: true, firstOpenedChat: false }),
      );

      if (!isEditing) {
        setOpenSuccessCreateModal(true);
      } else {
        navigate(routesManager.getProjectsRoute());
      }
    } catch (error) {
      let message = t("global.failureCreateMessage");
      if (isEditing) {
        message = t("global.failureUpdateMessage");
      }
      dispatch(
        actionDisplayNotification({
          messages: [message],
          severity: "error",
        }),
      );
      setDirt(true);
    } finally {
      setLoading(false);
      dispatch(actionSetLoading({ load: false, loadingProgess: 0, loadingText: "" }));
    }
  };

  async function fetchGrantedUser(projectId: string, userOwnerId?: number) {
    try {
      const res = await projectService.getGrantedUsers(projectId);
      const grantedUsers = res.map((user) => ({
        user: {
          email: user.email,
          name:
            microsoftUsers.find((microsoftUser) => microsoftUser.email === user.email)?.name || "",
        },
        delete: user.permissions.includes("files:delete"),
        upload: user.permissions.includes("files:upload"),
        change: false,
      }));
      setSelectedGrantedUsers(grantedUsers);
      const findUser = res.find((user) => user.id === userData?.id);
      const userThatsHasAccessToUpload = findUser?.permissions?.includes("files:upload");
      const userThatsHasAccessToDelete = findUser?.permissions?.includes("files:delete");
      const isAdmin = userData?.is_admin || userData?.is_superuser;
      const isOwner = userOwnerId === userData?.id;
      setAccessToUpload(isAdmin || isOwner || !!userThatsHasAccessToUpload);
      setAccessToDelete(isAdmin || isOwner || !!userThatsHasAccessToDelete);
      setAccessToDownload(isAdmin || isOwner || !formData.downloadDocs);
    } catch (er) {
      setAccessToUpload(false);
      setAccessToDelete(false);
    }
  }

  async function fetchSources(projectId: number) {
    const data = await sourcesService.listSources({
      projectId: projectId,
    });
    setSources(data);
  }

  async function fetchProject(projectId: number) {
    const data = await projectService.getProject(projectId);

    setEditKnowledgeId(data.knowledge_id);
    setMinScoreValue(data.min_score);
    setDocumentsValue(data.number_of_documents_retrived_to_context);
    setTemperatureValue(data.temperature);
    setIconValue(data.icon as string);

    setFormData({
      name: data.title,
      description: data.description,
      welcome_message: data.welcome_message,
      prompt: data.system_tone,
      isPublic: data.is_public,
      downloadDocs: formData.downloadDocs,
      internalKnowledgeOnly: data.internal_knowledge_only,
      owner: data.user_owner,
      temperature: data.temperature,
      seed: data.seed,
      number_of_documents_retrived_to_context: data.number_of_documents_retrived_to_context,
      min_score: data.min_score,
      external: data.external,
      priority: data.priority,
      model_id: data.model_id,
    });
    return data;
  }

  useEffect(() => {
    modelService.listModels().then((data) => setModels(data));

    if (id && parseInt(id) !== 0) {
      promptsService.prompt_in_a_project(parseInt(id)).then((data) => setPrompts(data));
    }
  }, []);

  useEffect(() => {
    if (id && parseInt(id) !== 0) {
      setLoading(true);
      (async () => {
        try {
          const project = await fetchProject(parseInt(id as string));
          await fetchGrantedUser(id, project?.user_owner.id);
          await fetchSources(parseInt(id as string));
        } catch {
          dispatch(
            actionDisplayNotification({
              messages: [t("global.failureRequestMessage")],
              severity: "error",
            }),
          );
          navigate(routesManager.getProjectsRoute());
        } finally {
          setLoading(false);
        }
      })();
    } else {
      setAccessToDelete(true);
      setAccessToUpload(true);
    }
  }, [id]);

  useEffect(() => {
    const handler = setTimeout(() => {
      validateForm();
    }, 600);

    return () => {
      clearTimeout(handler);
    };
  }, [formData]);

  function handleIconSelect(icon: string): void {
    setIconValue(icon);
  }

  const onFileDrop = (acceptedFiles: File[]) => {
    setDirt(true);
    setFilesToUpload((prevFiles) => [...prevFiles, ...acceptedFiles]);
    setSources((prevFiles) => [
      ...prevFiles,
      ...acceptedFiles.map((file) => ({
        id: uuidv4(),
        project_id: parseInt(id as string),
        file_name: file.name,
        media_type: file.type,
        size_in_bytes: file.size,
        file_path: "",
        knowledge_id: -1,
        processing_status: "pending_upload",
      })),
    ]);
  };

  const afterFileDelete = (deleted_source: ISource) => {
    setDirt(true);
    setSources((prev) => prev.filter((source) => source.id !== deleted_source.id));
  };
  const isCreating = !parseInt(id as string);

  const deleteConfirmationMessage = t(
    "pages.projects.components.createEditPage.dropzone.deleteConfirmationMessageAgent",
  );
  const inputHelperMessage = t(
    "pages.projects.components.createEditPage.dropzone.inputHelperAgent",
  );

  return (
    <ProjectDetailsContainer>
      {state === "blocked" ? (
        <ExitWithoutSaveModal
          isOpen={state === "blocked"}
          onConfirm={() => proceed()}
          toggle={() => reset!()}
        />
      ) : null}
      <LoadingOverlay />
      <SuccessCreateGPTModal
        isOpen={openSuccessCreateModal}
        toggle={() => setOpenSuccessCreateModal(false)}
      />
      <ShareGPTModal
        open={openShareModal}
        toggle={() => setOpenShareModal((prev) => !prev)}
        grantedUsers={selectedGrantedUsers}
        microsoftUsers={microsoftUsers}
        setGrantedUsers={setSelectedGrantedUsers}
      />
      <CreateModalAgentPrompt
        onAddPrompt={addToPrompts}
        projectId={parseInt(id as string)}
        ModalToggle={openAgentPromptModal}
        setModalToggle={setOpenAgentPromptModal}
        onConfirm={() => {
          setOpenAgentPromptModal(false);
        }}
      />
      <h2 className="page-title">
        {isEditing
          ? t("pages.projects.components.createEditPage.editTitle")
          : t("pages.projects.components.createEditPage.createTitle")}
      </h2>
      <CardVideo className="col-xxl-6">
        <div className="card">
          <div className="g-0 row">
            <div className="col-md-4">
              <a
                href="https://timenow.sharepoint.com/:v:/r/sites/ecossistemadesolucoes/Documentos%20Compartilhados/Documentos%20Kyno/Tutorial%20-%20Cria%C3%A7%C3%A3o%20de%20Agentes.mp4?csf=1&web=1&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D&e=5JMXLy"
                target="_blank"
                rel="noreferrer"
              >
                <img className="rounded-start img-fluid h-100 object-fit-cover" src={VideoCard} />
              </a>
            </div>
            <div className="col-md-8">
              <div className="card-header">
                <h5 className="card-title mb-0">
                  {t("pages.projects.components.createEditPage.cardTutorialTitle")}
                </h5>
              </div>
              <div className="card-body">
                <p className="card-text mb-2">
                  {t("pages.projects.components.createEditPage.cardTutorialText")}
                </p>
                <a
                  href="https://timenow.sharepoint.com/:v:/r/sites/ecossistemadesolucoes/Documentos%20Compartilhados/Documentos%20Kyno/Tutorial%20-%20Cria%C3%A7%C3%A3o%20de%20Agentes.mp4?csf=1&web=1&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D&e=5JMXLy"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button color="primary">
                    {t("pages.projects.components.createEditPage.cardTutorialButton")}
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </CardVideo>
      <GptForm onSubmit={handleSubmit}>
        <AgentDefinition>
          <div className="form-item">
            <h6 className="title">
              {t("pages.projects.components.createEditPage.agentDefinition").toUpperCase()}
            </h6>
            <Row>
              <Col md={10}>
                <Label htmlFor="gpt-name" className="form-label">
                  {t("pages.projects.components.createEditPage.name.label")}
                  {formData.name.trim() === "" && <span style={{ color: "red" }}> *</span>}
                </Label>
                <Input
                  type="text"
                  id="gpt-name"
                  name="name"
                  required
                  className="form-control"
                  disabled={loading || shouldDisableFields}
                  invalid={!!errors.name}
                  value={formData.name}
                  onChange={handleChange}
                />
                <FormInputText error={errors.name}>
                  <span>
                    {errors.name || t("pages.projects.components.createEditPage.name.inputHelper")}
                  </span>
                  <span>{formData.name.length}/20</span>
                </FormInputText>
              </Col>
              {/* icones começam aqui */}
              <Col md={2}>
                <Label htmlFor="gpt-name" className="form-label">
                  {t("pages.projects.components.createEditPage.icon")}
                </Label>
                <Dropdown
                  isOpen={isIconDropdown}
                  toggle={toggleIconDropdown}
                  className="w-100 bg-white"
                >
                  <DropdownToggle
                    className="w-100 btn btn-light bg-white"
                    style={{ borderColor: "#ced4da" }}
                  >
                    <img src={`/icons/${iconValue}`} />
                  </DropdownToggle>
                  <DropdownMenu style={{ minWidth: "100%" }}>
                    {iconPaths.map((icon, index) => (
                      <DropdownItem
                        key={index}
                        onClick={() => handleIconSelect(icon)}
                        className="d-flex justify-content-center"
                      >
                        <img src={`/icons/${icon}`} style={{ width: "20px", height: "20px" }} />
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </div>

          <div className="form-item">
            <Label htmlFor="gpt-description" className="form-label">
              {t("pages.projects.components.createEditPage.description.label")}
              {formData.description.trim() === "" && <span style={{ color: "red" }}> *</span>}
            </Label>
            <Input
              id="gpt-description"
              name="description"
              className="form-control"
              invalid={!!errors.description}
              disabled={loading || shouldDisableFields}
              type="textarea"
              rows={2}
              value={formData.description}
              onChange={handleChange}
            />
            <FormInputText error={errors.description}>
              <span>
                {errors.description ||
                  t("pages.projects.components.createEditPage.description.inputHelper")}
              </span>
              <span>{formData.description.length}/180</span>
            </FormInputText>
          </div>

          <div className="form-item">
            <Label htmlFor="gpt-welcome-message" className="form-label">
              {t("pages.projects.components.createEditPage.icebraker.label")}
              {formData.welcome_message?.trim() === "" && <span style={{ color: "red" }}> *</span>}
            </Label>
            <Input
              id="gpt-welcome-message"
              name="welcome_message"
              className="form-control"
              invalid={!!errors.welcome_message}
              disabled={loading || shouldDisableFields}
              type="textarea"
              rows={3}
              value={formData.welcome_message}
              onChange={handleChange}
            />
            <FormInputText error={errors.welcome_message}>
              <span>
                {errors.description ||
                  t("pages.projects.components.createEditPage.icebraker.inputHelper")}
              </span>
              <span>{(formData.welcome_message || "").length}/2500</span>
            </FormInputText>
          </div>

          <div className="form-item">
            <Label htmlFor="gpt-prompt" className="form-label">
              {t("pages.projects.components.createEditPage.basePrompt.label")}
            </Label>
            <div className="form-description">
              {t("pages.projects.components.createEditPage.basePrompt.description")}
            </div>
            <Input
              id="gpt-prompt"
              name="prompt"
              className="form-control"
              invalid={!!errors.prompt}
              disabled={loading || shouldDisableFields}
              type="textarea"
              rows={18}
              value={formData.prompt}
              onChange={handleChange}
            />
            <FormInputText error={errors.prompt}>
              <span>
                {errors.prompt ||
                  t("pages.projects.components.createEditPage.basePrompt.inputHelper")}
              </span>
              <span>{formData.prompt.length}/12000</span>
            </FormInputText>
          </div>
        </AgentDefinition>
        {userData?.is_superuser && (
          <AdvancedSettingsContainer>
            <h6 className="title">
              {t("pages.projects.components.createEditPage.advancedSettings.title").toUpperCase()}
            </h6>
            <Alert color="secondary" className="alert-border-left">
              <RiInformation2Line className="me-3 align-middle fs-16" />
              {t("pages.projects.components.createEditPage.advancedSettings.warning")}
            </Alert>
            <div className="form-item">
              <h6 className="form-label subtitle">
                {t("pages.projects.components.createEditPage.advancedSettings.model.title")}
              </h6>
              <FormInputText>
                {t("pages.projects.components.createEditPage.advancedSettings.model.subtitle")}
              </FormInputText>
              <Col md={6}>
                <Input
                  type="select"
                  id="gpt-model"
                  name="model_id"
                  required
                  className="form-control"
                  disabled={loading || shouldDisableFields}
                  value={formData.model_id}
                  onChange={handleChange}
                >
                  {models.map((model) => (
                    <option value={model.id} key={model.id}>
                      {model.identifier}
                    </option>
                  ))}
                </Input>
              </Col>
            </div>
            <div className="form-item mb-5">
              <h6 className="form-label subtitle">
                {t("pages.projects.components.createEditPage.advancedSettings.temperature.title")}
              </h6>
              <FormInputText>
                {t(
                  "pages.projects.components.createEditPage.advancedSettings.temperature.subtitle",
                )}
              </FormInputText>
              <Nouislider
                range={{ min: 0, max: 1 }}
                start={[temperatureValue]}
                step={0.1}
                connect={[true, false]}
                onSlide={handleSlideTemperature}
                id="product-price-range"
                pips={pipsOptionsFloatValues}
              />
            </div>
            <div className="form-item mb-5">
              <h6 className="form-label subtitle">
                {t("pages.projects.components.createEditPage.advancedSettings.minScore.title")}
              </h6>
              <FormInputText>
                {t("pages.projects.components.createEditPage.advancedSettings.minScore.subtitle")}
              </FormInputText>
              <Nouislider
                range={{ min: 0, max: 1 }}
                start={[minScoreValue]}
                step={0.1}
                connect={[true, false]}
                onSlide={handleSlideMinScore}
                id="product-price-range"
                pips={pipsOptionsFloatValues}
              />
            </div>
            <div className="form-item mb-5">
              <h6 className="form-label subtitle">
                {t("pages.projects.components.createEditPage.advancedSettings.document.title")}
              </h6>
              <FormInputText>
                {t("pages.projects.components.createEditPage.advancedSettings.document.subtitle")}
              </FormInputText>
              <Nouislider
                range={{ min: 0, max: 100 }}
                start={[documentsValue]}
                step={10}
                connect={[true, false]}
                onSlide={handleSlideDocuments}
                id="product-price-range"
                pips={pipsOptionsIntValues}
              />
            </div>
            <div className="form-item">
              <h6 className="form-label subtitle">ordenação</h6>
              <input
                type="number"
                className="form-control"
                id="basiInput"
                min="1"
                max="100"
                step="1"
                placeholder="priority"
                value={formData.priority}
                onChange={(e) => {
                  const target = e.target as HTMLInputElement;
                  const value = parseFloat(target.value);
                  if (value < 1) target.value = "1";
                  if (value > 100) target.value = "100";
                  setFormData((prevData) => ({
                    ...prevData,
                    priority: value,
                  }));
                }}
              />
            </div>
          </AdvancedSettingsContainer>
        )}

        <GptKnowledgeContainer>
          <h6 className="title">
            {t("pages.projects.components.createEditPage.knowledgeBase.title").toUpperCase()}
          </h6>
          <h6 className="subtitle">
            {t("pages.projects.components.createEditPage.knowledgeBase.documents")}
          </h6>
          <p className="description">
            {t("pages.projects.components.createEditPage.knowledgeBase.subtitle")}
            <a
              className="internal-policy-link"
              href="https://timenow.com.br/politica-de-protecao-de-dados/"
              target="_blank"
              rel="noreferrer"
            >
              {t("pages.projects.components.createEditPage.knowledgeBase.internalPolicy")}
            </a>
          </p>
          <DropzoneFile
            loading={loading}
            accessToDownload={accessToDownload}
            accessToDelete={accessToDelete && !isCreating}
            accessToUpload={accessToUpload}
            maxFileSize={HUNDRED_MB}
            sources={sources}
            afterDelete={afterFileDelete}
            onDrop={onFileDrop}
            deleteConfirmationMessage={deleteConfirmationMessage}
            inputHelperMessage={inputHelperMessage}
          />
          <div style={{ paddingTop: "4px" }} className="form-check form-switch">
            <Input
              className="form-check-input"
              type="checkbox"
              role="switch"
              disabled={loading || shouldDisableFields}
              name="downloadDocs"
              id="block-downloads"
              checked={formData.downloadDocs}
              onChange={handleChange}
            />
            <Label className="form-check-label" htmlFor="block-downloads">
              {t("pages.projects.components.createEditPage.privacity.download")}
            </Label>
          </div>
          <div className="form-check form-switch">
            <Input
              className="form-check-input"
              type="checkbox"
              role="switch"
              disabled={loading || shouldDisableFields}
              name="internalKnowledgeOnly"
              id="internal-knowledge"
              checked={!formData.internalKnowledgeOnly}
              onChange={handleChange}
            />
            <Label className="form-check-label" htmlFor="internal-knowledge">
              {t("pages.projects.components.createEditPage.knowledgeBase.externalKnowledge")}
            </Label>
          </div>
          {!formData.internalKnowledgeOnly && (
            <div className="form-check form-switch">
              <Input
                className="form-check-input"
                type="checkbox"
                role="switch"
                disabled={loading || shouldDisableFields}
                name="external"
                id="external"
                checked={formData.external}
                onChange={handleChange}
              />
              <Label className="form-check-label" htmlFor="external">
                {t("pages.projects.components.createEditPage.knowledgeBase.externalChat")}
              </Label>
            </div>
          )}
          {isEditing && (
            <>
              <div className="share-header-container">
                <h6 className="title">
                  {t("pages.projects.components.createEditPage.prompts.title").toUpperCase()}
                </h6>
                <Button
                  color="primary"
                  outline
                  type="button"
                  onClick={() => setOpenAgentPromptModal(true)}
                  disabled={loading || shouldDisableFields}
                  style={{ marginTop: "48px" }}
                >
                  {t("pages.projects.components.createEditPage.prompts.addBtn")}
                </Button>
              </div>
              <PromptsTable
                prompts={prompts}
                setPrompts={setPrompts}
                setDirt={setDirt}
                isEditing={isEditing}
                projectId={parseInt(id as string)}
                isOwner={
                  userData?.is_admin ||
                  userData?.is_superuser ||
                  formData.owner?.id === userData?.id
                }
              />
            </>
          )}

          {/* tabela de compartilhamento aqui para baixo */}
          <div className="share-header-container">
            <h6 className="title">
              {t("pages.projects.components.createEditPage.sharing.title").toUpperCase()}
            </h6>
            <Button
              color="primary"
              outline
              type="button"
              onClick={() => setOpenShareModal(true)}
              disabled={loading || shouldDisableFields}
              style={{ marginTop: "48px" }}
            >
              {t("pages.projects.components.createEditPage.sharing.shareBtn")}
            </Button>
          </div>
          <GrantedUsersTable
            grantedUsers={selectedGrantedUsers}
            setGrantedUsers={setSelectedGrantedUsers}
            setDirt={setDirt}
            isEditing={isEditing}
            projectId={parseInt(id as string)}
            isOwner={
              userData?.is_admin || userData?.is_superuser || formData.owner?.id === userData?.id
            }
          />
          {formData.isPublic || userData?.is_admin || userData?.is_superuser ? (
            <>
              <h6 className="subtitle">
                {t("pages.projects.components.createEditPage.privacity.title")}
              </h6>
              <div className="form-check form-switch">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  name="isPublic"
                  disabled={loading || shouldDisableFields}
                  id="public-gpt"
                  checked={formData.isPublic}
                  onChange={handleChange}
                />
                <Label className="form-check-label" htmlFor="public-gpt">
                  {t("pages.projects.components.createEditPage.privacity.label")}
                </Label>
              </div>
            </>
          ) : null}
        </GptKnowledgeContainer>
        <ActionButtonContainer>
          {shouldDisableFields && !dirt ? (
            <Button
              color="primary"
              type="button"
              onClick={() => navigate(routesManager.getProjectsRoute())}
              className="create-btn"
            >
              {t("global.back")}
            </Button>
          ) : (
            <>
              <Button
                color="danger"
                outline
                type="button"
                onClick={() => navigate(routesManager.getProjectsRoute())}
              >
                {t("global.cancel")}
              </Button>
              <Button
                color="primary"
                className="create-btn"
                disabled={loading || getHasError() || !getAllFieldsFilled(sources)}
              >
                {isEditing
                  ? t("pages.projects.components.createEditPage.editTitle")
                  : t("pages.projects.components.createEditPage.createTitle")}
              </Button>
            </>
          )}
        </ActionButtonContainer>
      </GptForm>
    </ProjectDetailsContainer>
  );
}
